import { render, staticRenderFns } from "./AddHouse.vue?vue&type=template&id=e0210402"
import script from "./AddHouse.vue?vue&type=script&lang=js"
export * from "./AddHouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports